import { type SqliteType, getSqliteType, isNumericType } from ".";

export function sqliteGreaterThan(a: unknown, b: unknown): boolean {
	// NULL comparisons always return NULL (which is falsy in boolean context)
	if (a === null || a === undefined || b === null || b === undefined) {
		return false;
	}

	// Convert to SQLite types
	const aType = getSqliteType(a);
	const bType = getSqliteType(b);

	// If both are numeric, compare as numbers
	if (isNumericType(aType) && isNumericType(bType)) {
		if (typeof a === "bigint" && typeof b === "bigint") {
			return a > b;
		}
		// Convert BigInt to number only when comparing with float
		const aNum = typeof a === "bigint" ? Number(a) : (a as number);
		const bNum = typeof b === "bigint" ? Number(b) : (b as number);
		return aNum > bNum;
	}

	// If both are text, compare as strings
	if (aType === "text" && bType === "text") {
		return String(a) > String(b);
	}

	// Different types follow SQLite type hierarchy: NULL < INTEGER < REAL < TEXT < BLOB
	return getSqliteTypeOrder(aType) > getSqliteTypeOrder(bType);
}

function getSqliteTypeOrder(type: SqliteType): number {
	switch (type) {
		case "null":
			return 0;
		case "integer":
			return 1;
		case "real":
			return 2;
		case "text":
			return 3;
		case "blob":
			return 4;
	}
}
